import prop from "ramda/es/prop";
import defaultToEmptyObject from "ramda-extension/es/defaultToEmptyObject";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../constants';
/**
 * Get codelists state
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getCodelists(state)
 *
 */ export const getCodelists = createSelector(prop(REDUCER_NAME), defaultToEmptyObject);
